
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"25","height":"40","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.836 16.772l.979.177 2.847-15.778a.995.995 0 0 0-1.806-.727L.166 24.037a.991.991 0 0 0-.012 1.081c.209.332.592.51.981.455l8.191-1.167L6.724 38.83a.995.995 0 0 0 1.806.727l15.689-23.593a.993.993 0 1 0-.969-1.535l-9.554 1.36.14.984.979.177-.979-.177.14.985 7.358-1.048-11.8 17.746 1.993-11.051a.995.995 0 0 0-1.119-1.162L3.051 23.29l11.8-17.746-1.993 11.051a.995.995 0 0 0 1.118 1.162l-.14-.985z"}})])
          )
        }
      }
    